import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { ReportGroup } from "../v1/ReportGroup";
import {
  MrfiktivReportGroupControllerGetParamsGen,
  MrfiktivCreateReportGroupDtoGen,
  MrfiktivUpdateReportGroupDtoGen
} from "../v1/data-contracts";

/**
 * Communicate with reportGroup API
 */
class ReportGroupService {
  mrfiktivProxy: ReportGroup;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new ReportGroup(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an reportGroup
   */
  async create(partnerId: string, data: MrfiktivCreateReportGroupDtoGen) {
    const reportGroup = (await this.mrfiktivProxy.reportGroupControllerCreate(partnerId, data)).data;

    return reportGroup;
  }

  /**
   * Get all reportGroup
   */
  async get(data: MrfiktivReportGroupControllerGetParamsGen) {
    const reportGroups = (await this.mrfiktivProxy.reportGroupControllerGet(data)).data;

    return reportGroups;
  }

  /**
   * Get a reportGroup
   */
  async getOne(partnerId: string, reportGroupId: string) {
    const reportGroup = (await this.mrfiktivProxy.reportGroupControllerGetOne(partnerId, reportGroupId)).data;

    return reportGroup;
  }

  /**
   * Update a reportGroup
   */
  async update(partnerId: string, reportGroupId: string, data: MrfiktivUpdateReportGroupDtoGen) {
    const reportGroup = (await this.mrfiktivProxy.reportGroupControllerUpdate(partnerId, reportGroupId, data)).data;

    return reportGroup;
  }

  /**
   * Delete a reportGroup
   */
  async delete(partnerId: string, reportGroupId: string) {
    const reportGroup = (await this.mrfiktivProxy.reportGroupControllerDelete(partnerId, reportGroupId)).data;

    return reportGroup;
  }
}

/**
 * Communicate with reportGroup API
 */
export default new ReportGroupService(new MrfiktivHttpClientProvider());
